import React, {useEffect, useState} from "react";
import {Form, Modal} from "antd";
import GeneralSeting from "../item/General";
import MidShiftSetting from "../item/MidShift";
import dayjs from "dayjs";
import {useDispatch, useSelector} from "react-redux";
import ModalShiftWork from "../item/ModalShiftWork";
import {t} from "i18next";
import {addShiftApi, loadShiftApi, updateShiftApi} from "../../../../../../api/setting/timekeeping/shift";
import ShiftMapper from "../../mapper/mapperShift"
import DG_Form from "../../../../../../custom/data-entry/form";
import DG_Submit from "../../../../../../common/button/Submit";
import DG_Cancel from "../../../../../../common/button/Cancel";
import DG_Button from "../../../../../../common/button/Button";
import {setHeader} from "../../../../../../redux/actions/layout/interaction/action";
import DescriptionTitle from "../../../timekeeping-settings/service/DescriptionTitle";
import useLazyRefetch from "../../../../../../custom/graphql/useLazyRefetch";
import {GET_SHIFT_CONFIGS} from "../../../../../../api/setting/timekeeping/shift/indexGql";
import {useSearchParams} from "react-router-dom";
import {TYPE_QUICK_ADD} from "../../../../../hrm/timekeeping/time-sheet/shift-assignment/items/Constant";
import {unFormatCurrency} from "../../../../../../format/Money";

const CreateContent = (props) => {
    const dispatch = useDispatch();
    const [arraySwitch, setArraySwitch] = useState({});
    const [arraySwitchMidShift, setArraySwitchMidShift] = useState({});
    useState(false);
    const [dataShift, setDataShift] = useState(false);

    const [form] = Form.useForm();

    const [visible, setVisible] = useState(false);
    const [dataShiftWork, setDataShiftWork] = useState([false]);
    const [dataShiftConfig, setDataShiftConfig] = useState();
    const [loading, setLoading] = useState(false)

    const [searchParams] = useSearchParams();
    const {fetchIfNeeded} = useLazyRefetch(GET_SHIFT_CONFIGS)
    const page = searchParams.get("page");
    const pageSize = searchParams.get("pageSize");
    const sort = searchParams.get("sort")
    const {filter, search} = useSelector(state => state.layoutInteractionReducer)


    useEffect(() => {
        if (!props.id) {
            dispatch(setHeader(t("shiftSider.titleAdd"), null))
        } else {
            dispatch(setHeader(t("shiftSider.titleUpdate"), null))
        }
    }, [props.id]);


    const onFinish = (values) => {

        values.totalWork = values.totalWork ? unFormatCurrency(values.totalWork) : 0;

        values.breakTimeStartHour = values.timeBreak ? dayjs(values.timeBreak)?.hour() : null;
        values.breakTimeStartMinute = values.timeBreak ? dayjs(values.timeBreak)?.minute() : null;
        delete values.timeBreak;

        values.breakTimeEndHour = values.endBreak ? dayjs(values.endBreak)?.hour() : null;
        values.breakTimeEndMinute = values.endBreak ? dayjs(values.endBreak)?.minute() : null;
        delete values.endBreak;

        values.flexibleHour = values.flexibleHours ? dayjs(values.flexibleHours)?.hour() : null;
        values.flexibleMinute = values.flexibleHours ? dayjs(values.flexibleHours)?.minute() : null;
        delete values.flexibleHours;

        values.checkOutBeforeHour = values.checkInLater ? dayjs(values.checkInLater)?.hour() : null;
        values.checkOutBeforeMinute = values.checkInLater ? dayjs(values.checkInLater)?.minute() : null;
        delete values.checkInLater;

        values.checkInBeforeHour = values.checkInFirst ? dayjs(values.checkInFirst)?.hour() : null;
        values.checkInBeforeMinute = values.checkInFirst ? dayjs(values.checkInFirst)?.minute() : null;
        delete values.checkInFirst;

        values.checkInBreakTimeStartHour = values.checkFirstShift ? dayjs(values.checkFirstShift)?.hour() : null;
        values.checkInBreakTimeStartMinute = values.checkFirstShift ? dayjs(values.checkFirstShift)?.minute() : null;
        delete values.checkFirstShift;


        values.checkInBreakTimeEndHour = values.checkNextShift ? dayjs(values.checkNextShift)?.hour() : null;
        values.checkInBreakTimeEndMinute = values.checkNextShift ? dayjs(values.checkNextShift)?.minute() : null;
        delete values.checkNextShift;

        delete values.totalHours;


        values.isInterval = arraySwitch.isInterval ? arraySwitch.isInterval : false;
        values.autoShiftApplyForDepartment = arraySwitch.autoShiftApplyForDepartment ? arraySwitch.autoShiftApplyForDepartment : false;
        values.autoShiftApplyForHoliday = arraySwitch.autoShiftApplyForHoliday ? arraySwitch.autoShiftApplyForHoliday : false;
        values.autoTimekeeping = arraySwitch.autoTimekeeping ? arraySwitch.autoTimekeeping : false;
        values.autoCheckoutPosition = arraySwitch.autoCheckoutPosition ? arraySwitch.autoCheckoutPosition : false;

        values.obligatoryMidShift = arraySwitchMidShift.obligatoryMidShift ? arraySwitchMidShift.obligatoryMidShift : false;
        values.isLateSoonBreak = arraySwitchMidShift.isLateSoonBreak ? arraySwitchMidShift.isLateSoonBreak : false;

        values.status = "actived"

        values.shiftIntervals = values?.shiftIntervals?.map((shiftIntervals) => {
            const fromHour = dayjs(shiftIntervals.timeIn)?.hour();
            const fromMinute = dayjs(shiftIntervals.timeIn)?.minute();
            const toHour = dayjs(shiftIntervals.timeOut)?.hour();
            const toMinute = dayjs(shiftIntervals.timeOut)?.minute();
            const isOverDay = shiftIntervals.isOverDay;
            return {
                fromHour,
                fromMinute,
                toHour,
                toMinute,
                isOverDay,
            };
        });

        if (values.shiftApplyForDepartmentIds === undefined) {
            values.shiftApplyForDepartmentIds = []
        }
        if (values.shiftApplyForPositionIds === undefined) {
            values.shiftApplyForPositionIds = []
        }
        if (values.shiftAutoCheckoutPositionIds === undefined) {
            values.shiftAutoCheckoutPositionIds = []
        }
        if (values.shiftApplyFors === undefined) {
            values.shiftApplyFors = []
        }

        values.timeBetweenCheckInHour = values?.timeBetweenCheckIn ? dayjs(values.timeBetweenCheckIn)?.hour() : 0;
        values.timeBetweenCheckInMinute = values?.timeBetweenCheckIn ? dayjs(values.timeBetweenCheckIn)?.minute() : 0;
        delete values?.timeBetweenCheckIn

        setLoading(true)
        if (!props.id) {
            addShiftApi(values).then(res => {

                if(props?.setFormData !== undefined){
                    props.setFormData(res)
                }

                // fetchIfNeeded({
                //     filter: filter || "isDeleted eq 'false'",
                //     page,
                //     pageSize,
                //     search,
                //     sort
                // }) --> not working
            }).finally(() => setLoading(false))

        } else {

            updateShiftApi(props.id, values).then(r => fetchIfNeeded({
                filter: filter || "isDeleted eq 'false'",
                page,
                pageSize,
                search,
                sort
            })).finally(() => setLoading(false))
        }
    };

    const onFinishFailed = (errorInfo) => {
    };

    const sendSwitch = (value) => {
        setArraySwitch(value);
    };
    const sendValueSwitchMidShift = (value) => {
        setArraySwitchMidShift(value);
    };

    const sendValueOnFinish = (value) => {
    };

    useEffect(() => {
        if (props.id) {
            loadShiftApi(props.id).then((response) => {
                form.setFieldsValue(ShiftMapper.mapShiftToIntShift(response));
                setDataShift(response);
            });
        } else {
            form.resetFields();
        }
    }, [props.id]);


    function putShiftConfig() {

    }

    const getValuesFromShiftWork = (values) => {
        updateShiftApi(props.id, values).then(r => {
        })
    };
    const handleCancel = (values) => {
        setVisible(values)

    };
    ;

    function handleCancelShiftWork() {
        setVisible(false)
    }

    return (
        <DG_Form form={form}
                 mode={props.mode}
                 onFinish={onFinish}
                 labelCol={{
                     span: 8,
                 }}
                 wrapperCol={{
                     span: 16,
                 }}
                 initialValues={{
                     remember: true,
                 }}
                 onFinishFailed={onFinishFailed}
                 autoComplete="off"
                 style={{
                     background: "#fff",
                     borderRight: "1px solid #EAECF0",
                     borderLeft: "1px solid #EAECF0",
                     borderTop: "1px solid #EAECF0",
                     height: "100%",
                     overflow: "hidden",
                 }}
        >

            <DG_Button title={props.mode === 'add' ? t("shiftMenu.addShift") : t("shiftMenu.editShift")} disableIcon={props.type === TYPE_QUICK_ADD}>
                <DG_Submit skipLoading={props.type === TYPE_QUICK_ADD} loading={loading}/>
                {props.type === TYPE_QUICK_ADD ? <></> : <DG_Cancel/>}
            </DG_Button>

            <div style={{overflow: 'auto', height: props?.type === TYPE_QUICK_ADD ? "90%" : "95%", padding: '16px'}}>
                <DescriptionTitle title={t("shiftSider.information")}/>
                <GeneralSeting
                    id={props?.id}
                    form={form}
                    sendSwitch={sendSwitch}
                    dataShift={dataShift}
                    sendValueOnFinish={sendValueOnFinish}
                />
                <MidShiftSetting
                    dataShift={dataShift}
                    sendValueSwitchMidShift={sendValueSwitchMidShift}
                />
            </div>

            {
                <Modal
                    onOk={putShiftConfig}
                    open={visible}
                    onCancel={handleCancelShiftWork}
                    title={"Áp dụng cấu hình cả cho các ca đã phân trước đó"}
                    cancelButtonProps={{type: "primary"}}
                    cancelText={<span className="width-60">{t("btn.cancel")}</span>}
                    okText={<span className="width-60">{t("btn.ok")}</span>}
                    okButtonProps={{type: "default"}}

                    footer={null}
                    width={1000}
                    bodyStyle={{

                        overflowY: "scroll",
                    }}
                >
                    <ModalShiftWork data={dataShiftWork}
                                    dataShiftConfig={dataShiftConfig}
                                    values={getValuesFromShiftWork}
                                    success={handleCancel}
                    />
                </Modal>
            }

        </DG_Form>
    );
};

export default CreateContent;
